<template>
  <div style="height: 100%">
    <div class="box-header box box-between">
      <div class="box-header-left">
        <div class="box-header-left-text">业务基础信息管理&nbsp;/&nbsp;</div>
        <div class="box-header-left-text">人员标签&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>标签管理</div>
        </div>
      </div>
      <div class="box">
        <el-button style="font-size: 16px" @click="cancel" size="mini">
          <template class="box box-column-center">
            <span>返回</span>
          </template>
        </el-button>
      </div>
    </div>
    <div class="section">
      <div class="left">
        <div class="title">标签类型</div>
        <div class="search-box">
          <el-input
            style="margin-right: 12px"
            placeholder="请输入"
            prefix-icon="el-icon-search"
            v-model="sxmc"
          >
          </el-input>
          <el-button
            style="
              width: 40px;
              height: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            @click="openDialog({})"
            class="search el-icon-plus button-info"
          ></el-button>
        </div>
        <div class="type-list">
          <div
            class="type-list-item"
            :class="{ active: ghEventTypeId == item.id }"
            v-for="(item, index) in typeList"
            :key="index"
            @click="typeChange(item)"
          >
            <div class="item-top">
              <div class="name">{{ item.tagType }}</div>
              <div class="item-bottom">
                <div class="edit">
                  <el-button
                    @click="openDialog(item)"
                    icon="el-icon-edit"
                    type="text"
                    ></el-button
                  >
                  <el-button
                    style="color: #eb3538"
                    @click="delEventTypeFun(item)"
                    icon="el-icon-delete"
                    type="text"
                    ></el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title mt-20 pt-20 border-top">标签列表</div>
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%;display: flex;justify-content: space-between;align-items: center;">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="标签名称">
                  <el-input
                    v-model="form.zbmc"
                    clearable
                    placeholder="请输入标签名称"
                  ></el-input>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search button-info">查询</el-button>
                </el-form-item>
              </el-form>
              <div style="display: flex;align-items: center;">
                <el-button
                  @click="openIssuesDialogFun()"
                  class="search el-icon-plus button-info"
                  >新增</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="aside">
          <common-table
            :maxHeight="460"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          >
            <template v-slot:operation="{ scope }">
              <!-- :disabled="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('COMPILE') ? false : true"
                :class="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('COMPILE') ? 'editClass' : ''" -->
              <el-button
                :disabled="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('COMPILE') ? false : true"
                :class="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('COMPILE') ? 'editClass' : ''"
                @click="openIssuesDialogFun(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >编辑</el-button
              >
              <!-- :disabled="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('DELETE') ? false : true"
                :class="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('DELETE') ? 'delClass' : ''" -->
              <el-button
                :disabled="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('DELETE') ? false : true"
                :class="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('DELETE') ? 'delClass' : ''"
                @click="delEventEditFun(scope.row.id)"
                style="color: #eb3538; font-size: 16px"
                type="text"
                >删除</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>

    <!-- 添加/编辑标签类型 -->
    <typeDialog
      v-if="dialogVisible"
      @refreshList="gettypeChange"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </typeDialog>

    <!-- 新增/编辑标签列表-->
    <issuesDialog
      v-if="issuesDialogVisible"
      @refreshList="eventPageFun"
      :dialogVisible.sync="issuesDialogVisible"
      :curItem="issuesCurItem"
      :typeList="typeList"
    >
    </issuesDialog>
  </div>
</template>

<script>
import {
  userTagtagTypes,
  userTagdelete,
  userTagpage
} from "@/api/base.js";
import commonTable from "@/components/table/index.vue";
import typeDialog from "./components/typeDialog.vue";
import issuesDialog from "./components/issuesDialog.vue";
export default {
  components: {
    commonTable,
    typeDialog,
    issuesDialog,
  },
  data() {
    return {
      curTypeItem: {},
      sxmc: "",
      form: {
        zbmc: "",
      },
      sfyjsxOptions: [
        {
          label: "是",
          value: "是"
        },
        {
          label: "否",
          value: "否"
        }
      ],
      dialogVisible: false,
      issuesDialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "tagName",
            label: "标签名称"
          },
          {
            prop: "createTime",
            label: "创建时间"
          },
          {
            slot: "operation",
            label: "操作",
          }
        ]
      },
      curItem: {},
      ruleCurItem: {},
      issuesCurItem: {},
      typeList: [],
      typeListAll: [],
      ghEventTypeId: null
    };
  },
  mounted() {
    this.selListFun();
  },
  methods: {
    //删除单条事项目录类型
    delEventTypeFun(item) {
      this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await userTagdelete({
            id: item.id
          });
          if (res.data.code == 200) {
            this.selListFun();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async gettypeChange (e) {
      const res = await userTagtagTypes({ 
        // tagType: this.sxmc,
        // page: 1,
        // size: 99999,
       });
      this.typeList = res.data.data || [];
      this.ghEventTypeId = this.typeList.find(item => item.id == e.curItem.id).id;
      this.curTypeItem = this.typeList.find(item => item.id == e.curItem.id);
    },
    typeChange(item) {
      this.ghEventTypeId = item.id;
      this.curTypeItem = item;
      this.eventPageFun();
    },
    openDialog(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    openIssuesDialogFun(item) {
      this.issuesDialogVisible = true;
      this.issuesCurItem = {
        editType: item ? "edit" : "add",
        dayTimes: 1,
        extendRangeMetre: null,
        extendLongitude: null,
        extendLatitude: null,
        extendAddress: null,
        ...this.curTypeItem,
        ...item,
        sxmcs: item && item.zbmc || '',
        ghEventTypeId: this.ghEventTypeId,
      };
      if (!item) {
        this.issuesCurItem.id = "";
      }
      // console.log(JSON.parse(JSON.stringify(this.issuesCurItem)))
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.eventPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.eventPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    onReset() {
      this.form.zbmc = "";
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    async selListFun(sxmc) {
      const res = await userTagtagTypes({ 
        // tagType: sxmc,
        // page: 1,
        // size: 99999,
       });
      this.typeList = res.data.data || [];
      this.typeListAll = res.data.data || [];
      this.ghEventTypeId = this.typeList.length ? this.typeList[0].id : "";
      this.eventPageFun();
      if (this.typeList.length > 0) {
        this.typeChange(this.typeList[0]);
      }
    },
    // 全局搜索标签类型
    selListFunFilter (sxmc) {
      if (!sxmc) this.typeList = this.typeListAll;
      else this.typeList = this.typeListAll.filter(item => item.tagType && item.tagType.indexOf(sxmc) != -1) || [];
      console.log(this.typeList)
      this.ghEventTypeId = this.typeList.length ? this.typeList[0].id : "";
      this.eventPageFun();
      if (this.typeList.length > 0) {
        this.typeChange(this.typeList[0]);
      }
    },
    
    async delEventEditFun(id) {
      const isok = await this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => true)
        .catch(() => false);
      if (!isok) {
        return;
      }
      const res = await userTagdelete({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.eventPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 分页查询
    async eventPageFun() {
      if (this.typeList.length === 0) {
        return;
      }
      let params = {
        tagName: this.form.zbmc,
        tagType: this.typeList.find(item => item.id == this.ghEventTypeId).tagType,
        page: this.page.page,
        size: this.page.size,
      };
      const res = await userTagpage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    },
    // 返回
    cancel() {
      this.$emit("closeDialog");
    }
  },
  watch: {
    sxmc: {
      deep: true,
      handler(sxmc) {
        this.selListFunFilter(sxmc);
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
/deep/ .button-info {
  background: #0054FE !important;
}
.box-father {
  padding-bottom: 24px;

  .section {
    display: flex;
    padding: 0;

    .left {
      width: 20%;
      height: 100%;
      overflow: auto;
      padding: 28px 24px;
      border-right: 1px solid #e0e0e0;
    }

    .right {
      width: 80%;
      height: 100%;
      padding: 28px 24px;
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
  }
}

.search-box {
  display: flex;
  margin-bottom: 12px;
}

.type-list {
  height: calc(100vh - 300px);
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 94px;
    padding: 12px;
    background: #f7faff;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .item-top {
      display: flex;
      align-items: center;

      .name {
        flex: 1;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
      }

      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
        margin: 0 0 6px 0;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edit {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .type-list-item.active {
    border: 1px solid #3caaff;
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}
.box {
  display: flex;
}
.box-wrap {
  flex-wrap: wrap;
}
.img-item {
  width: 110px;
  height: 110px;
  border-radius: 8px;
  margin: 0 8px 8px 0;
  position: relative;
  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 400;
    padding: 2px 0;
    border-radius: 0 0 8px 8px;
    text-align: center;
  }
}

.mt-20 {
  margin-top: 20px;
}

.pt-20 {
  padding-top: 20px;
}

.border-top {
  border-top: 1px solid #EEEEEE;
}

.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-2 {
  flex: 2;
}
.box-3 {
  flex: 3;
}
.box-7 {
  flex: 7;
}
.box-wrap {
  flex-wrap: wrap;
}
.box-column {
  flex-direction: column;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: 1px solid #e4e4e4;
}
.p-15 {
  padding: 15px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.bold {
  font-weight: bold;
}
.w100 {
  width: 130px;
}
.mb-10 {
  margin-bottom: 10px;
}
.pointer {
  cursor: pointer;
}
.mt-16 {
  margin-top: 16px;
}
.p-10 {
  padding: 10px;
}
.editClass {
  color: #0090ff;
  font-size: 16px;
}
.delClass {
  color: #eb3538;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/personLabel/detail.vue